<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col class="consumptionlists">
        <div>
          <p>{{ DetialCountObj.Issued }}</p>
          <p>Issued</p>
        </div>
        <div>
          <p class="notreturned">{{ DetialCountObj.Returned }}</p>
          <p>Returned</p>
        </div>
        <div>
          <p>{{ DetialCountObj.Consumed }}</p>
          <p>Consumed</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="consumptiontable">
        <Tableview
          :value="items"
          :paginator="true"
          class="p-datatable-gridlines"
          :rows="10"
          :rowHover="true"
          filterDisplay="menu"
          :loading="loading"
          responsiveLayout="scroll"
          :columns="headers"
          :globalFilterFields="globalFilterFields"
          :filters="filters"
          selectionMode="single"
          dataKey="ID"
        >
          <template v-slot:Status="{ data }">
            <Badge v-if="data.IsActive == '0'" severity="warning">{{
              "InActive"
            }}</Badge>
            <Badge v-if="data.IsActive == '1'" severity="success">{{
              "Active"
            }}</Badge>
          </template>
        </Tableview>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";

import PatientIssueService from "../../../../../modules/Inventory/Service/PatientIssueService";

export default defineComponent({
  components: {
    Tableview,
  },
  props: {
    FilterObj: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const items = ref([]);
    const loading = ref(false);
    const route = useRoute();
    const router = useRouter();

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    interface Obj {
      HospitalId: number | 0;
      BranchId: number | 0;
      StoreId: number | 0;
      Date: string;
    }

    const Obj = ref<Obj>({
      HospitalId: usersData.OrganizationId,
      BranchId: Number(route.query.BranchId),
      StoreId: Number(route.query.Id),
      Date: moment().format("YYYY-MM-DD"),
    });

    interface DetialCountObj {
      Issued: number | 0;
      Returned: number | 0;
      Consumed: number | 0;
    }

    const DetialCountObj = ref<DetialCountObj>({
      Issued: 0,
      Returned: 0,
      Consumed: 0,
    });

    //DataTable Fields
    const headers = [
      {
        header: "S.No",
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: "To store name",
        field: "ToStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "UIN",
        field: "PatientId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Patient Name",
        field: "PatientName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Allocated Lens Diaptor",
        field: "AllocatedLense",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Issued",
        field: "IssuedCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "width150",
      },
      {
        header: "Returned",
        field: "ReturnCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Consumed",
        field: "ConsumedCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
      TemplateInfo: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    onMounted(() => {
      LoadConsumptionDetails();
    });

    watch(
      () => [props.FilterObj.Date],
      ([newFilterObj]) => {
        debugger;
        if (newFilterObj) {
          Obj.value.Date = newFilterObj;
          LoadConsumptionDetails();
        }
      },
      { immediate: true }
    );

    const LoadConsumptionDetails = async (): Promise<void> => {
      debugger;
      try {
        const response =
          await PatientIssueService.GetConsumptionDetailsByStoreId(Obj.value);

        DetialCountObj.value.Issued =
          response["result"].DetailCounts[0].IssuedCount;
        DetialCountObj.value.Returned =
          response["result"].DetailCounts[0].ReturnCount;
        DetialCountObj.value.Consumed =
          response["result"].DetailCounts[0].ConsumedCount;

        let RowNumber = 0;
        items.value = response["result"].PatientConsumptionList.map((x) => {
          RowNumber = RowNumber + 1;
          x.RowNumber = RowNumber;
          return x;
        });
      } catch (error) {
        console.error("Error loading consumption details:", error);
      }
    };

    return {
      items,
      loading,
      filteredColumns,
      globalFilterFields,
      headers,
      filters,
      DetialCountObj,
    };
  },
});
</script>

<style lang="scss">
.consumptiontable .p-datatable-wrapper {
  margin-top: 15%;
}

.consumptionlists {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 18%;

  div {
    padding: 30px 15px 15px 15px;
    border: 1px solid #e1e1e1;
    border-left-width: 0px;
    color: #999999;

    p:first-child {
      font-size: 40px;
    }

    .notreturned {
      color: #ff5f57;
    }
  }

  div:first-child {
    border-left-width: 1px;
  }
}
</style>
